import { Spinner } from '@quickmd-llc/design-system'

type Props = {
  contained?: boolean
}

export function RoomLoadingSpinner({ contained }: Props = {}) {
  return (
    <div
      className={`absolute inset-0 z-[999999999] flex items-center justify-center ${contained ? 'bg-black/30' : 'pointer-events-none'}`}>
      <Spinner
        style={{ width: 50, height: 50, zIndex: 99999, position: 'absolute' }}
        className='animate-spin text-neutral-5'
      />
    </div>
  )
}
